import { InjectionToken } from '@angular/core';

export interface MediaConfig {
  base: string;
}

export const MEDIA_CONFIG = new InjectionToken<MediaConfig>('MEDIA_CONFIG');
